import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import './navbarToggler.css';

class NavBarToggler extends Component {
	constructor(props) {
		super(props);
		this.onClick = (() => {
			if (!!props.onClick) return props.onClick.bind(this);
			else return () => {};
		})();
	}

	render() {
		return (
			<Button
				className='show-on-991'
				color={'primary'}
				onClick={() => {
					this.onClick(!this.props.isExtended);
				}}>
				<div className={`toggle-icon${!!this.props.isExtended ? ' toggle-icon_open' : ''}`}>
					<span />
					<span />
					<span />
				</div>
			</Button>
		);
	}
}

export default NavBarToggler;



// WEBPACK FOOTER //
// ./src/components/navbarToggler.js